const LightroomImportIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="28" viewBox="0 0 38 28" fill="none">
    <path
      d="M35.9999 14C35.9999 20.6274 30.6274 26 23.9999 26C18.8623 26 14.4788 22.7713 12.7676 18.2323L11.2372 19.7627C13.4339 24.6202 18.3222 28 23.9999 28C31.7319 28 37.9999 21.732 37.9999 14C37.9999 6.26801 31.7319 0 23.9999 0C18.0516 0 12.9697 3.70968 10.9417 8.9417L12.5141 10.5141C14.0075 5.58676 18.5849 2 23.9999 2C30.6274 2 35.9999 7.37258 35.9999 14Z"
      fill="#1C1C1C"
    />
    <path
      d="M6.67655 21.7379L13.0405 15.3739C13.431 14.9834 13.431 14.3502 13.0405 13.9597L6.67656 7.59573C6.28604 7.20521 5.65287 7.20521 5.26235 7.59573C4.87182 7.98626 4.87182 8.61942 5.26235 9.00995L9.9192 13.6668L1 13.6668C0.447716 13.6668 0 14.1145 0 14.6668C0 15.2191 0.447715 15.6668 1 15.6668L9.9192 15.6668L5.26234 20.3237C4.87182 20.7142 4.87182 21.3473 5.26234 21.7379C5.65287 22.1284 6.28603 22.1284 6.67655 21.7379Z"
      fill="#1C1C1C"
    />
    <path
      d="M18 11C18 10.4477 17.5523 10 17 10C16.4477 10 16 10.4477 16 11V17C16 17.5523 16.4477 18 17 18H20C20.5523 18 21 17.5523 21 17C21 16.4477 20.5523 16 20 16H18V11Z"
      fill="#1C1C1C"
    />
    <path
      d="M22.5 12C21.9477 12 21.5 12.4477 21.5 13V17C21.5 17.5523 21.9477 18 22.5 18C23.0523 18 23.5 17.5523 23.5 17V14H24.5C25.0523 14 25.5 13.5523 25.5 13C25.5 12.4477 25.0523 12 24.5 12H22.5Z"
      fill="#1C1C1C"
    />
    <path
      d="M30 12C28.8954 12 28 12.8954 28 14C28 15.1046 28.8954 16 30 16C30.5129 16 30.9786 15.8083 31.3331 15.491C31.7446 15.1226 32.3768 15.1577 32.7451 15.5692C33.1135 15.9807 33.0784 16.6129 32.6669 16.9812C31.9599 17.614 31.0238 18 30 18C27.7909 18 26 16.2091 26 14C26 11.7909 27.7909 10 30 10C31.0238 10 31.9599 10.386 32.6669 11.0188C33.0784 11.3871 33.1135 12.0193 32.7451 12.4308C32.3768 12.8423 31.7446 12.8774 31.3331 12.509C30.9786 12.1917 30.5129 12 30 12Z"
      fill="#1C1C1C"
    />
  </svg>
);

export default LightroomImportIcon;
